var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.range
        ? _c("date-picker", {
            staticClass: "range-date",
            attrs: {
              range: "",
              type: "date",
              placeholder: _vm.$t("insert.chooseDate"),
              format: "YYYY-MM-DD",
              "value-type": "format",
              disabled: _vm.disabled
            },
            on: {
              input: function($event) {
                return _vm.input($event)
              }
            },
            model: {
              value: _vm.selectedValue,
              callback: function($$v) {
                _vm.selectedValue = $$v
              },
              expression: "selectedValue"
            }
          })
        : _c("b-form-datepicker", {
            attrs: {
              "date-format-options": _vm.formatOption,
              locale: "tr",
              disabled: _vm.disabled,
              placeholder: _vm.$t("insert.chooseDate")
            },
            on: {
              input: function($event) {
                return _vm.input($event)
              }
            },
            model: {
              value: _vm.selectedValue,
              callback: function($$v) {
                _vm.selectedValue = $$v
              },
              expression: "selectedValue"
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-383c4842", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-383c4842","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NextDatePicker.vue
// module id = null
// module chunks = 